import { asyncRetryWithTimeout, throwDevError } from '@/src/general/utils/errors'

import { getSwRegistration } from './getSwRegistration'

const urlBase64ToUint8Array = (base64String: string) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export const subscribePush = async () => {
  if (!('Notification' in window) || !('PushManager' in window)) {
    return null
  }

  console.debug(`Trying to get a push subscription...`)

  const registration = await getSwRegistration()

  if (!registration?.active) {
    console.debug('No active registration found: cannot get subscription.', { registration })
    return null
  }

  try {
    return asyncRetryWithTimeout(
      () =>
        registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(
            'BKFITWBJvDJBQyRqpNB17nIy0p4xyuvyc-HgS7O87Mb0dUkMWRePnWdk8DD-Mr6Z-6NBqqQfrr8gk2u3Feqtkq8',
          ),
        }),
      {
        attempts: 3,
        attemptTime: 3000,
        delayBetweenAttempts: 500,
        timeoutMessage: 'registration.pushManager.subscribe - timeout',
      },
    )
  } catch (error) {
    throwDevError('An error occurred while trying to registration.pushManager.subscribe({ ... })', { cause: error })
  }
  return null
}
